if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      var config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      var formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }

      this.formIdInputValue = this.form.querySelector('[name=id]').value;
      if (this.formIdInputValue.includes(',')) {
          formData.delete('id');
          formData.delete('quantity');
      }

      let urlSuffix = '';
      if(document.querySelector(`[data-product-subscription-bundle-main]`)){
        urlSuffix = '.js';
        let timestamp = Date.now();
        config.headers =  { "Accept": "application/json", "Content-Type": "application/json" };
        let ItemsArr = [];
        let itemObj = {
            id: `${formData.get("id")}`,
            quantity: Number(document.querySelector(`[data-pro-subscription-bundle-item].active`).dataset.quantity),
            properties:{
                _timestamp: timestamp,
                _flavors_product: true
            },
            selling_plan: document.querySelector(`[data-pro-subscription-bundle-item].active`).dataset.sellingPlan
        }
        let counter = 0;
        document.querySelectorAll(`[data-pro-subscription-steps-flavors-item]`).forEach((flavor,index) => {
          if(flavor.querySelector(`[data-flavors-qty-value]`).innerHTML != "0"){
            counter++;
            itemObj[`properties`][`flavor_${counter}_name`] = flavor.querySelector(`[data-flavors-qty-value]`).dataset.flavors;
            itemObj[`properties`][`flavor_${counter}_qty`] = flavor.querySelector(`[data-flavors-qty-value]`).innerHTML;
          }
        });
        ItemsArr.push(itemObj);

        document.querySelectorAll(`.pro-subs-gift-list .pro-subs-gift-item.unlocked`).forEach((freeGiftItem) => {
          ItemsArr.push({
            id: freeGiftItem.dataset.variantId,
            quantity: 1,
            properties: {
              _timestamp: timestamp,
              _free_product: true
            }
          });  
        });
        // console.log("iiiiiiiiii",{"items":ItemsArr});
        // debugger;
        config.body = JSON.stringify({
          items:ItemsArr,
          sections: this.cart.getSectionsToRender().map((section) => section.id),
          sections_url: window.location.pathname
        });
        // console.log("formData",config.body);
      }else{        
        config.body = formData;
      }

      this.skipCart = false;
      if (this.form.querySelector('[name=id]').dataset.skipCart && this.form.querySelector('[name=id]').dataset.skipCart === 'true') {
        this.skipCart = true;
      }

      fetch(`${routes.cart_add_url}${urlSuffix}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (this.skipCart) {
            window.location = "/checkout";
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form'});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

// new js for subscription bundle
if(document.querySelector(`[data-product-subscription-bundle-main]`)){
  let sellingPlans = document.querySelectorAll(`[data-pro-subscription-bundle-item]`);
  sellingPlans.forEach(item => {
    // console.log("item",item);
    item.addEventListener("click",function(e){
      e.preventDefault();
      // console.log("plan changed");
      document.querySelector(`[data-pro-subscription-bundle-item].active`)?.classList.remove("active");
      item.classList.add("active");
      document.querySelectorAll(`[data-pro-subscription-steps-flavors-item] [data-flavors-qty-value]`).forEach(qtyEle => {
        qtyEle.innerHTML = 0;
      });
      document.querySelector(`.product-form__submit`)?.setAttribute("disabled","disabled");
      if(document.querySelector(`.product-form__submit span`)) document.querySelector(`.product-form__submit span`).innerHTML = item.dataset.buttonLabel;
      // free gift unlocked
      document.querySelectorAll(`.pro-subs-gift-list .pro-subs-gift-item`).forEach((freeGiftItem,index) => {
        // limitQty
        if(index < Number(this.dataset.quantity)){
          freeGiftItem.classList.add("unlocked");
        }else{
          freeGiftItem.classList.remove("unlocked");
        }
      });

      // change msgs above atc btn
      if(document.querySelector(".prod-subs-msg.active")) document.querySelector(".prod-subs-msg.active").classList.remove("active");
      if(document.querySelector(`.prod-subs-msg[data-quantity="${this.dataset.quantity}"]`)) document.querySelector(`.prod-subs-msg[data-quantity="${this.dataset.quantity}"]`).classList.add("active");
      // chage benefits below atc btn
      if(document.querySelector(".prod-subs-benefits-item.active")) document.querySelector(".prod-subs-benefits-item.active").classList.remove("active");
      if(document.querySelector(`.prod-subs-benefits-item[data-quantity="${this.dataset.quantity}"]`)) document.querySelector(`.prod-subs-benefits-item[data-quantity="${this.dataset.quantity}"]`).classList.add("active");
    });
  });

  let qtyBtns = document.querySelectorAll(`[data-pro-subscription-steps-flavors-item] [data-flavors-qty-btn]`);
  qtyBtns.forEach(btn => {
    btn.addEventListener("click",function(e){
      e.preventDefault();
      // console.log("qty btn clicked");
      let limitQty = Number(document.querySelector(`[data-pro-subscription-bundle-item].active`).dataset.quantity);
      let currentQty = 0;
      document.querySelectorAll(`[data-pro-subscription-steps-flavors-item] [data-flavors-qty-value]`).forEach(qtyEle => {
        currentQty += Number(qtyEle.innerHTML);
      });
      if(this.dataset.label == "minus"){
        if(currentQty != 0 && this.closest(`[data-pro-subscription-steps-flavors-item]`).querySelector(`[data-flavors-qty-value]`).innerHTML != "0"){
          this.closest(`[data-pro-subscription-steps-flavors-item]`).querySelector(`[data-flavors-qty-value]`).innerHTML = Number(this.closest(`[data-pro-subscription-steps-flavors-item]`).querySelector(`[data-flavors-qty-value]`).innerHTML) - 1;
        }
      }else{
        if(currentQty < limitQty){
          this.closest(`[data-pro-subscription-steps-flavors-item]`).querySelector(`[data-flavors-qty-value]`).innerHTML = Number(this.closest(`[data-pro-subscription-steps-flavors-item]`).querySelector(`[data-flavors-qty-value]`).innerHTML) + 1;
        }
      }
      let finalCurrentQty = 0;
      document.querySelectorAll(`[data-pro-subscription-steps-flavors-item] [data-flavors-qty-value]`).forEach(qtyEle => {
        finalCurrentQty += Number(qtyEle.innerHTML);
      });
      if(limitQty == finalCurrentQty){
        document.querySelector(`.product-form__submit`)?.removeAttribute("disabled");
        if(document.querySelector(`.product-form__submit span`)) document.querySelector(`.product-form__submit span`).innerHTML = document.querySelector(`.product-form__submit`).dataset.label;
      }else{
        document.querySelector(`.product-form__submit`)?.setAttribute("disabled","disabled");
        if(document.querySelector(`.product-form__submit span`)) document.querySelector(`.product-form__submit span`).innerHTML = document.querySelector(`[data-pro-subscription-bundle-item].active`).dataset.buttonLabel;
      }
    });
  });
}